import React from "react";
import classNames from "classnames/dedupe";
import { TTableProps } from "./TableModels.interface";

/**
 * Add more keys as we access the data object
 */
export interface ITableRequiredData {
  id: string;
}

/**
 * The Table component takes in data and columns as props,
 * then renders a TableHeader and TableRows.
 */
function Table<T extends ITableRequiredData, K extends keyof T>({
  title = "",
  data,
  columns,
  selectedItem = "",
  classes,
}: TTableProps<T, K>): JSX.Element {
  const headers = columns.map((column) => {
    return <th key={`headCell-${column.header}`}>{column.header}</th>;
  });

  // highlighted

  const rows = data.map((row) => {
    return (
      <tr
        key={`row-${row.id}`}
        className={classNames({
          highlighted: selectedItem && selectedItem === row.id,
        })}
      >
        {columns.map((column) => (
          <td key={`cell-${row[column.key]}`}>{row[column.key] as string}</td>
        ))}
      </tr>
    );
  });

  return (
    <table className={classNames("table table-striped", classes?.root)}>
      {title && <caption>{title}</caption>}
      <thead>
        <tr>{headers}</tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
}

export default Table;
